import React from 'react';
import { COLOR_PRESETS } from '../constants';
import sidePanelStyles from '../../../../styles/SidePanel.module.css';

interface ColorPickerProps {
  selectedColor: string;
  onColorChange: (color: string) => void;
}

const ColorPicker: React.FC<ColorPickerProps> = ({ selectedColor, onColorChange }) => {
  return (
    <div className={sidePanelStyles.colorPickerContainer}>
      <div className={sidePanelStyles.colorPickerWrapper}>
        <div 
          className={sidePanelStyles.colorPreview}
          style={{ backgroundColor: selectedColor }}
        >
          <input
            type="color"
            className={sidePanelStyles.colorPickerInput}
            value={selectedColor}
            onChange={(e) => onColorChange(e.target.value)}
          />
        </div>
        <div className={sidePanelStyles.colorInfo}>
          <div className={sidePanelStyles.colorName}>Category Theme Color</div>
          <div className={sidePanelStyles.colorValue}>{selectedColor}</div>
        </div>
      </div>
      <div className={sidePanelStyles.colorPalette}>
        {COLOR_PRESETS.map(color => (
          <button
            key={color}
            type="button"
            className={`${sidePanelStyles.presetColor} ${selectedColor === color ? sidePanelStyles.active : ''}`}
            style={{ backgroundColor: color }}
            onClick={() => onColorChange(color)}
            title={color}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorPicker;

